import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type ITemplateDealStage, templateDealStagesManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { getters } from './getters';

const TEMPLATE_DEAL_STAGE_MODULE = 'templateDealStage';

const dataObjectModule = getDataObjectsModule<ITemplateDealStage>(templateDealStagesManager, 3);
const searchModule = getSearchModule<ITemplateDealStage>(templateDealStagesManager);

const templateDealStageModuleInstance = merge<unknown>(dataObjectModule, searchModule, { getters });
store.registerModule(TEMPLATE_DEAL_STAGE_MODULE, templateDealStageModuleInstance);

export { TEMPLATE_DEAL_STAGE_MODULE };
